import { render, staticRenderFns } from "./FormTicketingBlockGeneralSettings.vue?vue&type=template&id=6f513625"
import script from "./FormTicketingBlockGeneralSettings.vue?vue&type=script&lang=js"
export * from "./FormTicketingBlockGeneralSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports